import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import usePhotos from '../../hooks/usePhotos.js';
import LoadingSpinner from '../common/LoadingSpinner.jsx';
import ErrorMessage from '../common/ErrorMessage.jsx';
import s3BucketUrl from '../../config/s3-bucket-url.js';

const Signature = ({ name, title, email, phone, ext, other, picture }) => {
    const { error, loading, getCurrentImage, image } = usePhotos();

    useEffect(() => {
        const fetchData = async () => {
            await getCurrentImage();
        };

        fetchData();
    }, []);

    return (
        <>
            <div
                style={{
                    marginTop: '10em',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '85%',
                    marginBottom: '5em'
                }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        width: '25em'
                    }}>
                    <div style={{ marginRight: '2em' }}>
                        <img
                            src={picture}
                            alt="profile pic"
                            style={{
                                height: '112px',
                                width: '112px',
                                borderRadius: '50%'
                            }}
                        />
                    </div>
                    <div>
                        <p
                            style={{
                                fontSize: '.85em',
                                marginBottom: '0em',
                                marginTop: '0em'
                            }}>
                            <b>{name}</b>
                        </p>
                        <p
                            style={{
                                fontSize: '.85em',
                                marginBottom: '0em',
                                marginTop: '0em'
                            }}>
                            <em>{title}</em>
                        </p>
                        <p
                            style={{
                                fontSize: '.85em',
                                marginBottom: '0em',
                                marginTop: '0em'
                            }}>
                            Practice Booster & eAssist Publishing, LLC
                        </p>
                        <p
                            style={{
                                fontSize: '.85em',
                                marginBottom: '0em',
                                marginTop: '0em'
                            }}>
                            {email}
                        </p>
                        {phone && ext && (
                            <p
                                style={{
                                    fontSize: '.85em',
                                    marginBottom: '0em',
                                    marginTop: '0em'
                                }}>
                                {phone} Ext. {ext}
                            </p>
                        )}{' '}
                        {phone && !ext && (
                            <p
                                style={{
                                    fontSize: '.85em',
                                    marginBottom: '0em',
                                    marginTop: '0em'
                                }}>
                                {phone}
                            </p>
                        )}
                        {other.map((o) => (
                            <p
                                style={{
                                    fontSize: '.85em',
                                    marginBottom: '0em',
                                    marginTop: '0em'
                                }}
                                key={uuidv4()}>
                                {o}
                            </p>
                        ))}
                        <div style={{ height: '.8em' }} />
                        <div>
                            <a
                                href="https://www.facebook.com/PracticeBooster/"
                                target="_blank"
                                rel="noreferrer">
                                <img
                                    src={`${s3BucketUrl}/facebook-20x20.png`}
                                    alt="facebook"
                                    style={{
                                        marginRight: '3px',
                                        width: '18px'
                                    }}
                                />
                            </a>
                            <a
                                href="https://www.instagram.com/practicebooster/"
                                target="_blank"
                                rel="noreferrer">
                                <img
                                    src={`${s3BucketUrl}/instagram-20x20.png`}
                                    alt="instagram"
                                    style={{
                                        marginRight: '3px',
                                        width: '18px'
                                    }}
                                />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/practicebooster"
                                target="_blank"
                                rel="noreferrer">
                                <img
                                    src={`${s3BucketUrl}/linkedin-20x20.png`}
                                    alt="linkedin"
                                    style={{
                                        marginRight: '3px',
                                        width: '18px'
                                    }}
                                />
                            </a>
                            <a
                                href="https://www.pinterest.com/practicebooster"
                                target="_blank"
                                rel="noreferrer">
                                <img
                                    src={`${s3BucketUrl}/pinterest-20x20.png`}
                                    alt="pinterest"
                                    style={{
                                        marginRight: '3px',
                                        width: '18px'
                                    }}
                                />
                            </a>
                            <a
                                href="https://www.youtube.com/@practicebooster5738"
                                target="_blank"
                                rel="noreferrer">
                                <img
                                    src={`${s3BucketUrl}/youtube-20x20.png`}
                                    alt="youtube"
                                    style={{
                                        marginRight: '3px',
                                        width: '18px'
                                    }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ height: '12px' }} />
                {image && (
                    <img
                        src={image.imageUrl}
                        alt="practice booster logo"
                        style={{ width: '300px' }}
                    />
                )}
                {loading && <LoadingSpinner />}
                <p style={{ fontSize: '12px', width: '800px' }}>
                    <em>
                        This transmission and any attached information represent
                        privileged and confidential information intended solely
                        for the named recipient(s). If you received this
                        transmission in error, please notify the sender
                        immediately, destroy any hard copy, and delete any
                        material from your system. If you are not the intended
                        recipient, any disclosure, copying, distribution, or use
                        of the contents of this transmission and attachments for
                        any reason is strictly prohibited.
                    </em>
                </p>
            </div>
            {error && <ErrorMessage message={error.message} />}
        </>
    );
};

Signature.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    ext: PropTypes.oneOfType([PropTypes.number, PropTypes.null]).isRequired,
    other: PropTypes.array.isRequired,
    picture: PropTypes.string.isRequired
};

export default Signature;
